<template>
  <main class="usage-terms-create">
    <usage-terms-form v-if="usageTerm"
                      :item="usageTerm"
                      :admin="isAdminUsageTerms" />
  </main>
</template>

<script>
    import UsageTermsForm from '@views/usage-terms/components/UsageTermsForm.vue'

    export default {
        components: {
          UsageTermsForm
        },

        data() {
            return {
              usageTerm: undefined
            }
        },

        computed: {
          isAdmin() {
            return this.$store.state.users.admin && !this.$store.state.users.user
          },            
          user() {
            return this.$store.state.users.user
          },  
          userId() {
            return this.isAdmin ? 0 : this.user.id
          },
          isAdminUsageTerms() {
            return this.$route.path.includes('/admin')
          }                    
        },

        methods: {
          async getUsageTerms() {
            try {
              const usageTerm = await this.$api.usageTerms.get({
                usageTermId: this.$route.params.usageTermId,
                userId: this.userId
              })

              this.usageTerm = usageTerm;
            } catch (error) {
              console.log(error)
            }
          }
        },


        created() {
          this.getUsageTerms()
        },

        beforeDestroy() {
        },
    }
</script>

<style lang="scss" scoped>
</style>
